const serviceAreas = {
  serviceAreas: {
    pageHeader: 'サービスエリア',
    description:
      '住宅所有者が特定の地域でEnphase設置業者を検索する場合、Enphase では、入力された %{regionOrCountyLabel} をもとに、その地域で貴社がサービスの提供が可能かどうかを確認します。',
    addNewArea: '新しいエリアを追加する',
    new: '新規',
    areaName: 'エリア名',
    servicesCovered: {
      countiesCovered: '対象の郡',
      regionsCovered: '対象の地域',
      provincesCovered: '対象の州',
      regionsWithCount: '対象の %{region} (郵便番号の最初の %{typeCharacters} 桁）',
      districtsCovered: '対象の地区',
      citiesCovered: '対象の自治体',
      citiesCoveredbr: '対象の都市',
      departments: '部署',
      regions: '地域',
      counties: '郡',
      districts: '区',
      cities: '市町村',
      provinces: '州',
      city: '都市'
    },
    selectAllCounty: '特定の州からすべての %{regionOrCountyLabel} を選択する',
    selectAllCountyWithRegion: '特定の地域からすべての %{regionOrCountyLabel} を選択する',
    selectAllDepartment: 'すべての部署を選択',
    addCountiesRegionsButton: '%{regionOrCountyLabel} を追加',
    countyButtonDescription: '選択した州に基づいて、関連するすべての %{regionOrCountyLabel} が追加されます',
    countyButtonDescriptionWithRegion: '選択した地域に基づいて、関連するすべての %{regionOrCountyLabel} が追加されます',
    area1: 'エリア1',
    selectState: '州を選択',
    selectRegion: '地域を選択',
    requestNotProcessed: 'リクエストを処理できませんでした',
    footerTitle:
      '参考価格には、設置、架台、PVモジュール、インバーターなどの費用を含める必要があります。屋根の葺き替え、メインパネルのアップグレードなどの費用が追加される場合があります。',
    footerBody:
      'Enphaseは、この参考価格を住宅所有者に提供します。Enphaseは、この価格設定が暫定的なものであり、変更される可能性があるという免責事項を住宅所有者に提供します。',
    noBlankRegions: `対象の %{regionOrCountyLabel} を空白にすることはできません`,
    //noBlankCounties: `対象の郡を空白にすることはできません`,
    deleteConfirmation: 'このサービスエリアを削除してもよろしいですか？',
    ok: 'Ok',
    infoText: `%{bTagOpen}地域%{bTagClose} は、%{stateOrProvince} の郵便番号の最初の %{count} 桁で定義されます`,
    infoTextFr: `部署は郵便番号の最初の2桁で定義される`,
    state: '都道府県',
    province: '州',
    noOptions: 'オプションなし'
  }
};

export default serviceAreas;
